// ===================================
// TODO CLEAN - QUOTE MODAL
// Modal with quote request form
// ===================================

import React from 'react';
import Modal from './Modal';
import PriceCalculator from '../sections/PriceCalculator';
import { useQuoteModal } from '@/contexts/QuoteModalContext';

// ==========================================
// QUOTE MODAL COMPONENT
// ==========================================

const QuoteModal: React.FC = () => {
  const { isOpen, closeModal } = useQuoteModal();

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      title="Solicita tu Cotización Gratis"
      maxWidth="lg"
    >
      <PriceCalculator onSuccess={closeModal} />
    </Modal>
  );
};

export default QuoteModal;
